import { render, staticRenderFns } from "./ReturnabilityByServiceGroupSubHeader.vue?vue&type=template&id=527401fc&scoped=true"
import script from "./ReturnabilityByServiceGroupSubHeader.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByServiceGroupSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527401fc",
  null
  
)

export default component.exports